import React, { useState, useRef, useEffect } from 'react';
import './../../../assets/css/admin/AdminChat.css';
import AdminLayout from '../../../layouts/AdminLayout/AdminLayout';

// ── Data ─────────────────────────────────────────────────────────────────────
const CONVERSATIONS = [
  {
    id: 1, priority: 'urgent', type: 'student',
    name: 'Sara Raza', initials: 'SR',
    course: 'Web Development · Batch A', isOnline: true,
    lastMessage: 'My mentor never responds to my messages...',
    time: '2m ago', unread: 3,
    conflict: {
      title: 'Unresponsive Mentor',
      desc: 'Mentor Ahmed Khan has not responded for 5 days. Student has an assignment due Friday.',
      tags: ['Urgent', 'Mentor Issue', 'Deadline Risk'],
    },
    stats: { progress: 72, tickets: 3, joined: 'Feb 2024' },
    courseProgress: [
      { label: 'Web Development', pct: 72 },
      { label: 'Assignments Done', pct: 67, display: '8/12' },
    ],
    participants: [
      { initials: 'SR', name: 'Sara Raza',   role: 'Student', color: '#fce7f3', text: '#9d174d' },
      { initials: 'AK', name: 'Ahmed Khan',  role: 'Mentor',  color: '#f5f3ff', text: '#6d28d9' },
    ],
    timeline: [
      { dot: '#dc2626', text: 'Conflict ticket opened by Sara',              time: 'Today, 9:02 AM' },
      { dot: '#781c2e', text: 'Admin sent mentor alert notification',         time: 'Today, 9:15 AM' },
      { dot: '#d97706', text: 'Backup session scheduled with Zara Hassan',   time: 'Today, 9:18 AM' },
      { dot: '#10b981', text: 'Mentor Ahmed responded — medical emergency',  time: 'Today, 10:42 AM' },
    ],
  },
  {
    id: 2, priority: 'conflict', type: 'mentor',
    name: 'Ahmed Khan', initials: 'AK',
    course: 'React.js Advanced · All Batches', isOnline: false,
    lastMessage: 'The student submitted late work and expects full marks...',
    time: '18m ago', unread: 2,
    conflict: {
      title: 'Grade Dispute',
      desc: 'Mentor and student disagree on grading policy for late submissions.',
      tags: ['Grade Dispute', 'Policy', 'Student Complaint'],
    },
    stats: { progress: 0, tickets: 2, joined: 'Jan 2024' },
    courseProgress: [],
    participants: [
      { initials: 'AK', name: 'Ahmed Khan',  role: 'Mentor',  color: '#f5f3ff', text: '#6d28d9' },
      { initials: 'LH', name: 'Layla Hussain', role: 'Student', color: '#fce7f3', text: '#9d174d' },
    ],
    timeline: [
      { dot: '#dc2626', text: 'Grade dispute reported by student',  time: 'Today, 8:00 AM' },
      { dot: '#781c2e', text: 'Mentor submitted grading rationale', time: 'Today, 8:45 AM' },
    ],
  },
  {
    id: 3, priority: 'active', type: 'student',
    name: 'Fatima Malik', initials: 'FM',
    course: 'UI/UX Design · Batch B', isOnline: true,
    lastMessage: 'Thank you so much for resolving this so quickly!',
    time: '1h ago', unread: 0,
    conflict: null,
    stats: { progress: 88, tickets: 1, joined: 'Mar 2024' },
    courseProgress: [{ label: 'UI/UX Design', pct: 88 }],
    participants: [
      { initials: 'FM', name: 'Fatima Malik', role: 'Student', color: '#fce7f3', text: '#9d174d' },
    ],
    timeline: [
      { dot: '#10b981', text: 'Issue resolved successfully', time: 'Yesterday' },
    ],
  },
  {
    id: 4, priority: 'active', type: 'mentor',
    name: 'Zara Hassan', initials: 'ZH',
    course: 'Python Data Science', isOnline: false,
    lastMessage: 'Regarding the curriculum update for next semester...',
    time: '3h ago', unread: 1,
    conflict: null,
    stats: { progress: 0, tickets: 0, joined: 'Nov 2023' },
    courseProgress: [],
    participants: [
      { initials: 'ZH', name: 'Zara Hassan', role: 'Mentor', color: '#f5f3ff', text: '#6d28d9' },
    ],
    timeline: [],
  },
  {
    id: 5, priority: 'active', type: 'student',
    name: 'Omar Butt', initials: 'OB',
    course: 'Web Development · Batch C', isOnline: true,
    lastMessage: 'Can I switch my mentor to someone else in the batch?',
    time: 'Yesterday', unread: 0,
    conflict: null,
    stats: { progress: 41, tickets: 1, joined: 'Apr 2024' },
    courseProgress: [{ label: 'Web Development', pct: 41 }],
    participants: [
      { initials: 'OB', name: 'Omar Butt', role: 'Student', color: '#fce7f3', text: '#9d174d' },
    ],
    timeline: [],
  },
];

const MESSAGES = {
  1: [
    { id: 1, senderInitials: 'SR', senderName: 'Sara Raza',  role: 'Student', isMe: false, color: '#fce7f3', textColor: '#9d174d',
      text: 'Hello Admin, I have been trying to reach my mentor Ahmed Khan for 5 days now. He hasn\'t responded to any of my messages or scheduled sessions.', time: '9:02 AM' },
    { id: 2, senderInitials: 'SR', senderName: 'Sara Raza',  role: 'Student', isMe: false, color: '#fce7f3', textColor: '#9d174d',
      text: 'I have an assignment deadline this Friday and I need guidance. This is really affecting my learning progress. Please help!', time: '9:04 AM' },
    { id: 3, senderInitials: 'AD', senderName: 'You', role: 'Admin', isMe: true, color: '#ede8df', textColor: '#5c1422',
      text: 'Hi Sara, I understand your frustration and I\'m taking this matter seriously. I\'ve flagged this as urgent and will reach out to Ahmed Khan immediately.', time: '9:15 AM' },
    { id: 4, type: 'system', text: '🔔 Admin notified mentor Ahmed Khan via system alert', time: '9:15 AM' },
    { id: 5, senderInitials: 'AD', senderName: 'You', role: 'Admin', isMe: true, color: '#ede8df', textColor: '#5c1422',
      text: 'In the meantime, I\'ve arranged a temporary session with mentor Zara Hassan who is available today at 3 PM. Does that work for you?', time: '9:18 AM' },
    { id: 6, senderInitials: 'SR', senderName: 'Sara Raza', role: 'Student', isMe: false, color: '#fce7f3', textColor: '#9d174d',
      text: 'Yes, 3 PM works perfectly! Thank you so much for the quick response. I really appreciate it.', time: '9:21 AM' },
    { id: 7, senderInitials: 'AK', senderName: 'Ahmed Khan', role: 'Mentor', isMe: false, color: '#f5f3ff', textColor: '#6d28d9',
      text: 'Admin, I sincerely apologize. I had a medical emergency and forgot to update my availability. I\'ve contacted Sara directly now.', time: '10:42 AM' },
    { id: 8, type: 'system', text: '✓ Session scheduled: Sara Raza ↔ Zara Hassan — Today 3:00 PM', time: '10:45 AM' },
  ],
  2: [
    { id: 1, senderInitials: 'LH', senderName: 'Layla Hussain', role: 'Student', isMe: false, color: '#fce7f3', textColor: '#9d174d',
      text: 'I submitted my project 2 days late due to a family emergency. My mentor gave me a 0 but I think that\'s unfair.', time: '8:05 AM' },
    { id: 2, senderInitials: 'AD', senderName: 'You', role: 'Admin', isMe: true, color: '#ede8df', textColor: '#5c1422',
      text: 'Layla, I understand. Let me review the platform late submission policy and speak to Ahmed Khan about this case.', time: '8:20 AM' },
    { id: 3, senderInitials: 'AK', senderName: 'Ahmed Khan', role: 'Mentor', isMe: false, color: '#f5f3ff', textColor: '#6d28d9',
      text: 'The policy is clear — late submissions without prior approval get 0. I followed the rules. This wasn\'t a surprise to the student.', time: '8:45 AM' },
  ],
  3: [
    { id: 1, senderInitials: 'FM', senderName: 'Fatima Malik', role: 'Student', isMe: false, color: '#fce7f3', textColor: '#9d174d',
      text: 'Hi, I just wanted to say thank you so much for resolving my scheduling issue so quickly!', time: 'Yesterday' },
    { id: 2, senderInitials: 'AD', senderName: 'You', role: 'Admin', isMe: true, color: '#ede8df', textColor: '#5c1422',
      text: 'Happy to help Fatima! Your session has been rescheduled. Please let me know if anything else comes up.', time: 'Yesterday' },
    { id: 3, senderInitials: 'FM', senderName: 'Fatima Malik', role: 'Student', isMe: false, color: '#fce7f3', textColor: '#9d174d',
      text: 'Thank you so much for resolving this so quickly!', time: 'Yesterday' },
  ],
  4: [
    { id: 1, senderInitials: 'ZH', senderName: 'Zara Hassan', role: 'Mentor', isMe: false, color: '#f5f3ff', textColor: '#6d28d9',
      text: 'Hi! Regarding the curriculum update for next semester — can we discuss adding more practical projects?', time: '3h ago' },
  ],
  5: [
    { id: 1, senderInitials: 'OB', senderName: 'Omar Butt', role: 'Student', isMe: false, color: '#fce7f3', textColor: '#9d174d',
      text: 'Can I switch my mentor to someone else in the batch? I feel like the current mentor\'s teaching style isn\'t matching my learning pace.', time: 'Yesterday' },
  ],
};

// ── Helpers ───────────────────────────────────────────────────────────────────
const ROLE_STYLE = {
  Student: { bg: '#dbeafe', color: '#1d4ed8' },
  Mentor:  { bg: '#f5f3ff', color: '#6d28d9' },
  Admin:   { bg: '#ede8df', color: '#5c1422' },
};

const PRIORITY_COLOR = { urgent: '#dc2626', conflict: '#d97706', active: '#781c2e' };

// ── Component ─────────────────────────────────────────────────────────────────
const AdminChat = () => {
  const [activeId,    setActiveId]    = useState(1);
  const [filter,      setFilter]      = useState('all');
  const [search,      setSearch]      = useState('');
  const [input,       setInput]       = useState('');
  const [messages,    setMessages]    = useState({ ...MESSAGES });
  const [showInfo,    setShowInfo]    = useState(true);
  const [resolved,    setResolved]    = useState({});
  const messagesEndRef = useRef(null);

  const selected = CONVERSATIONS.find(c => c.id === activeId);

  const filtered = CONVERSATIONS.filter(c => {
    const matchSearch = c.name.toLowerCase().includes(search.toLowerCase());
    const matchFilter = filter === 'all'
      || (filter === 'conflicts' && c.conflict)
      || (filter === 'students'  && c.type === 'student')
      || (filter === 'mentors'   && c.type === 'mentor');
    return matchSearch && matchFilter;
  });

  const urgent   = filtered.filter(c => c.priority === 'urgent');
  const conflict = filtered.filter(c => c.priority === 'conflict');
  const active   = filtered.filter(c => c.priority === 'active');

  useEffect(() => {
    messagesEndRef.current?.scrollIntoView({ behavior: 'smooth' });
  }, [activeId, messages]);

  const handleSend = () => {
    const txt = input.trim();
    if (!txt) return;
    const newMsg = {
      id: (messages[activeId]?.length || 0) + 1,
      senderInitials: 'AD', senderName: 'You', role: 'Admin',
      isMe: true, color: '#ede8df', textColor: '#5c1422',
      text: txt, time: new Date().toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit' }),
    };
    setMessages(prev => ({ ...prev, [activeId]: [...(prev[activeId] || []), newMsg] }));
    setInput('');
  };

  const ConvRow = ({ c }) => (
    <div
      className={`conv-item ${c.priority} ${activeId === c.id ? 'active' : ''}`}
      onClick={() => setActiveId(c.id)}
    >
      <div className="av-wrap">
        <div className="av-initials"
          style={{ background: c.type === 'student' ? '#fce7f3' : '#f5f3ff',
                   color: c.type === 'student' ? '#9d174d' : '#6d28d9' }}>
          {c.initials}
        </div>
        {c.isOnline && <span className="dot-on" />}
        <span className={`role-tag ${c.type === 'student' ? 'role-s' : 'role-m'}`}>
          {c.type === 'student' ? 'S' : 'M'}
        </span>
      </div>
      <div className="conv-body">
        <div className="conv-row1">
          <span className="conv-name">{c.name}</span>
          <span className="conv-time">{c.time}</span>
        </div>
        <div className="conv-row2">
          <span className="conv-last">{c.lastMessage}</span>
          {c.unread > 0 && (
            <span className={`conv-badge ${c.priority === 'urgent' ? 'badge-red' : c.priority === 'conflict' ? 'badge-amber' : ''}`}>
              {c.unread}
            </span>
          )}
        </div>
      </div>
    </div>
  );

  return (
    <AdminLayout>

    <div className="adm-root">

      {/* ══════════ SIDEBAR ══════════ */}
      <div className="adm-sidebar">
        <div className="sb-top">
          <div className="sb-title-row">
            <h2 className="sb-heading">Admin Messages</h2>
            <button className="new-btn" title="New Conversation">+</button>
          </div>
          <div className="search-box">
            <span className="search-ic">&#9906;</span>
            <input
              type="text" placeholder="Search conversations..."
              value={search} onChange={e => setSearch(e.target.value)}
            />
          </div>
        </div>

        <div className="filter-bar">
          {['all', 'conflicts', 'students', 'mentors'].map(f => (
            <button key={f}
              className={`filter-btn ${filter === f ? 'f-active' : ''}`}
              onClick={() => setFilter(f)}>
              {f.charAt(0).toUpperCase() + f.slice(1)}
            </button>
          ))}
        </div>

        <div className="conv-list">
          {urgent.length > 0 && (
            <>
              <div className="list-section-header urgent-h">&#9670; Urgent</div>
              {urgent.map(c => <ConvRow key={c.id} c={c} />)}
            </>
          )}
          {conflict.length > 0 && (
            <>
              <div className="list-section-header conflict-h">&#9670; Conflicts</div>
              {conflict.map(c => <ConvRow key={c.id} c={c} />)}
            </>
          )}
          {active.length > 0 && (
            <>
              <div className="list-section-header">&#9670; Active</div>
              {active.map(c => <ConvRow key={c.id} c={c} />)}
            </>
          )}
        </div>
      </div>

      {/* ══════════ CHAT PANEL ══════════ */}
      <div className="adm-chat">

        {/* Header */}
        <div className="chat-header">
          <div className="ch-left">
            <div className="av-initials ch-av"
              style={{ background: selected?.type === 'student' ? '#fce7f3' : '#f5f3ff',
                       color: selected?.type === 'student' ? '#9d174d' : '#6d28d9' }}>
              {selected?.initials}
            </div>
            <div className="ch-meta">
              <div className="ch-name-row">
                <h3 className="ch-name">{selected?.name}</h3>
                <span className="ch-role-pill"
                  style={{ background: selected?.type === 'student' ? '#dbeafe' : '#f5f3ff',
                           color: selected?.type === 'student' ? '#1d4ed8' : '#6d28d9' }}>
                  {selected?.type === 'student' ? 'Student' : 'Mentor'}
                </span>
              </div>
              <div className="ch-sub">
                {selected?.isOnline && <span className="online-dot" />}
                <span className={selected?.isOnline ? 'online-txt' : 'offline-txt'}>
                  {selected?.isOnline ? 'Online' : 'Offline'}
                </span>
                <span className="ch-course">&nbsp;&bull;&nbsp;{selected?.course}</span>
              </div>
            </div>
          </div>
          <div className="ch-actions">
            <button className="icon-btn" title="Search in chat">&#128269;</button>
            <button className="icon-btn" title="Add participant">+</button>
            <button className="icon-btn" title="Schedule session">&#128337;</button>
            <button className={`icon-btn ${showInfo ? 'icon-active' : ''}`}
              title="Toggle info panel"
              onClick={() => setShowInfo(p => !p)}>
              &#9776;
            </button>
          </div>
        </div>

        {/* Conflict banner */}
        {selected?.conflict && !resolved[activeId] && (
          <div className="conflict-banner">
            <span className="cb-icon">&#9888;</span>
            <span className="cb-text">
              <strong>Active Conflict:</strong> {selected.conflict.title} &nbsp;&bull;&nbsp; {selected.conflict.desc.slice(0, 72)}...
            </span>
            <button className="cb-btn" onClick={() => setResolved(p => ({ ...p, [activeId]: true }))}>
              Mark Resolved
            </button>
          </div>
        )}
        {resolved[activeId] && (
          <div className="resolved-banner">
            <span>&#10003;&nbsp; Conflict marked as resolved</span>
          </div>
        )}

        {/* Messages */}
        <div className="messages-area">
          <div className="date-chip"><span>Today — {new Date().toLocaleDateString('en-US',{month:'long',day:'numeric',year:'numeric'})}</span></div>

          {(messages[activeId] || []).map(msg => {
            if (msg.type === 'system') {
              return (
                <div key={msg.id} className="sys-msg">
                  <span>{msg.text}</span>
                </div>
              );
            }
            return (
              <div key={msg.id} className={`msg ${msg.isMe ? 'msg-me' : 'msg-other'}`}>
                {!msg.isMe && (
                  <div className="msg-av" style={{ background: msg.color, color: msg.textColor }}>
                    {msg.senderInitials}
                  </div>
                )}
                <div className="msg-body">
                  <div className="msg-sender">
                    {msg.senderName}
                    <span className="role-chip"
                      style={{ background: ROLE_STYLE[msg.role]?.bg, color: ROLE_STYLE[msg.role]?.color }}>
                      {msg.role}
                    </span>
                  </div>
                  <div className={`msg-bubble ${msg.isMe ? 'bubble-me' : 'bubble-other'}`}>
                    <p>{msg.text}</p>
                  </div>
                  <span className="msg-time">{msg.time}</span>
                </div>
                {msg.isMe && (
                  <div className="msg-av" style={{ background: '#ede8df', color: '#5c1422' }}>AD</div>
                )}
              </div>
            );
          })}
          <div ref={messagesEndRef} />
        </div>

        {/* Input */}
        <div className="input-area">
          <div className="tool-chips">
            <button className="tool-chip">&#128196; Attach File</button>
            <button className="tool-chip">&#128337; Schedule</button>
            <button className="tool-chip">&#9888; Escalate</button>
            <button className="tool-chip" onClick={() => setResolved(p => ({...p,[activeId]:true}))}>&#10003; Close Ticket</button>
          </div>
          <div className="input-row">
            <input
              type="text"
              placeholder={`Reply to ${selected?.name}...`}
              value={input}
              onChange={e => setInput(e.target.value)}
              onKeyDown={e => e.key === 'Enter' && handleSend()}
            />
            <button className="icon-btn" title="Emoji">&#128578;</button>
            <button className="send-btn" onClick={handleSend}>&#10148;</button>
          </div>
        </div>
      </div>

      {/* ══════════ INFO PANEL ══════════ */}
      {showInfo && selected && (
        <div className="adm-info">

          <div className="info-hero">
            <div className="info-av"
              style={{ background: selected.type === 'student' ? '#fce7f3' : '#f5f3ff',
                       color: selected.type === 'student' ? '#9d174d' : '#6d28d9' }}>
              {selected.initials}
            </div>
            <div className="info-name">{selected.name}</div>
            <span className="info-role-pill"
              style={{ background: selected.type === 'student' ? '#dbeafe' : '#f5f3ff',
                       color: selected.type === 'student' ? '#1d4ed8' : '#6d28d9' }}>
              {selected.type === 'student' ? '● Student' : '● Mentor'}
            </span>
            <div className="info-stats">
              {selected.type === 'student' && (
                <div className="istat">
                  <div className="istat-val">{selected.stats.progress}%</div>
                  <div className="istat-lbl">Progress</div>
                </div>
              )}
              <div className="istat">
                <div className="istat-val">{selected.stats.tickets}</div>
                <div className="istat-lbl">Tickets</div>
              </div>
              <div className="istat">
                <div className="istat-val">{selected.stats.joined.split(' ')[0]}</div>
                <div className="istat-lbl">Joined</div>
              </div>
            </div>
          </div>

          {/* Conflict Details */}
          {selected.conflict && (
            <div className="isec">
              <div className="isec-title">&#9888; Conflict Details</div>
              <div className={`conflict-card ${resolved[activeId] ? 'conflict-card-resolved' : ''}`}>
                <div className="cc-title">
                  {selected.conflict.title}
                  {resolved[activeId] && <span className="resolved-chip">Resolved</span>}
                </div>
                <div className="cc-desc">{selected.conflict.desc}</div>
                <div className="cc-tags">
                  {selected.conflict.tags.map(t => <span key={t} className="ctag">{t}</span>)}
                </div>
              </div>
            </div>
          )}

          {/* Participants */}
          <div className="isec">
            <div className="isec-title">&#128101; Participants</div>
            <div className="participants">
              {selected.participants.map((p, i) => (
                <div key={i} className="pchip">
                  <div className="pc-av" style={{ background: p.color, color: p.text }}>{p.initials}</div>
                  <span className="pc-name">{p.name}</span>
                  <span className="pc-role" style={{ background: ROLE_STYLE[p.role]?.bg, color: ROLE_STYLE[p.role]?.color }}>
                    {p.role}
                  </span>
                </div>
              ))}
              <div className="pchip pchip-me">
                <div className="pc-av" style={{ background: '#781c2e', color: '#fff' }}>AD</div>
                <span className="pc-name">You (Admin)</span>
                <span className="pc-role" style={{ background: '#ede8df', color: '#5c1422' }}>Admin</span>
              </div>
            </div>
          </div>

          {/* Course Progress */}
          {selected.courseProgress.length > 0 && (
            <div className="isec">
              <div className="isec-title">&#128202; Course Progress</div>
              {selected.courseProgress.map((p, i) => (
                <div key={i} className="prog-row">
                  <div className="prog-label">
                    <span>{p.label}</span>
                    <span className="prog-pct">{p.display || `${p.pct}%`}</span>
                  </div>
                  <div className="prog-bar"><div className="prog-fill" style={{ width: `${p.pct}%` }} /></div>
                </div>
              ))}
            </div>
          )}

          {/* Timeline */}
          {selected.timeline.length > 0 && (
            <div className="isec">
              <div className="isec-title">&#128336; Activity Log</div>
              <div className="timeline">
                {selected.timeline.map((t, i) => (
                  <div key={i} className="tl-item">
                    <div className="tl-dot" style={{ background: t.dot }} />
                    <div className="tl-body">
                      <div className="tl-text">{t.text}</div>
                      <div className="tl-time">{t.time}</div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}

          {/* Actions */}
          <div className="info-actions">
            <button className="abtn abtn-primary">&#128337; Schedule Group Session</button>
            <button className="abtn abtn-outline">&#8596; Reassign Mentor</button>
            <button className="abtn abtn-danger">&#9873; Escalate to Management</button>
          </div>

        </div>
      )}
    </div>
    </AdminLayout>  
  );
};

export default AdminChat;